import { ref } from 'vue';
import axios from 'axios';
import { sanitizeHtml } from '../utils/sanitize';

export function usePaketLayanan() {
  const paketList = ref([]);
  const isLoading = ref(false);
  const error = ref(null);

  const fetchPaketLayanan = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const { data } = await axios.get('/frontend/paket-layanan');
      paketList.value = data.map((paket) => ({
        ...paket,
        deskripsi: sanitizeHtml(paket.deskripsi),
      }));
    } catch (err) {
      error.value = err;
    } finally {
      isLoading.value = false;
    }
  };

  const getPaketByKode = (kode) => {
    return paketList.value.find((p) => p.kode_paket === kode);
  };

  return {
    paketList,
    isLoading,
    error,
    fetchPaketLayanan,
    getPaketByKode,
  };
}
